<template>
  <div class="pufa-page">
    <img src="//download-cos.yofish.com/bank-gongjushiyebu/20221230153757660-home-bg.png" alt="">
    <div class="rule-btn" @click="jumpRule">
      <img src="//download-cos.yofish.com/bank-gongjushiyebu/2022123015391564-rule-btn.png" alt="">
    </div>
    <div class="bottom-btn">
      <div class="btns">
        <div class="btn" @click="jumpDetails">
          <img src="//download-cos.yofish.com/ad-gongjushiyebu/2022071415014111-btn1.png" alt="">
        </div>
        <div class="btn" @click="visible = true">
          <img src="//download-cos.yofish.com/ad-gongjushiyebu/20220714150201209-btn2.png" alt="">
        </div>
      </div>
    </div>
    <y-dialog :visible="visible" class="pufa-dialog">
      <div class="dialog-content">
        您暂未获得活动资格
      </div>
      <div slot="footer" class="footer-btn" @click="visible = false">
        <span>我知道了</span>
      </div>
    </y-dialog>
    <y-dialog :visible="visible1">
      <div class="head">
        <img src="~@/assets/images/leaflet/frame.png" alt="" width="100%">
      </div>
      <div class="apply-content">
        <div class="input">
          <input type="text" placeholder="请输入手机号码" v-model="phoneNumber" />
        </div>
      </div>
      <div class="apply-btn" @click="submitAction">
        <img src="~@/assets/images/leaflet/submit-btn.png" width="100%" alt="">
      </div>
      <div class="check-module">
        <div class="image" @click="isChecked = !isChecked">
          <img :src="imgUrl" alt="" />
        </div>
        <span>我同意以下协议</span>
      </div>
      <div class="agreement-content">
        <y-agreement />
      </div>
    </y-dialog>
  </div>
</template>
<script>
import YDialog from '@/components/dialog';
import { getUploadClickAction, getPublicize } from '@/api/base';
import YAgreement from '@/components/agreement';

export default {
  name: 'Pufa',
  components: {
    YDialog,
    YAgreement,
  },
  data() {
    return {
      visible: false,
      visible1: false,
      phoneNumber: '',
      isChecked: false,
    };
  },
  mounted() {
    document.title = '浦发银行活动页';
    this.getPublicize();
  },
  computed: {
    imgUrl() {
      const { isChecked } = this;
      return !isChecked ? require('@/assets/images/leaflet/no-checked.png')
        : require('@/assets/images/leaflet/checked.png');
    },
  },
  methods: {
    jumpRule() {
      this.$router.push('/leaflet/pufa/rule');
    },
    jumpDetails() {
      this.visible1 = true;
    },
    jumpUrl() {
      this.$router.push({
        path: '/leaflet/jump',
        query: {
          paramV: 'fdgsdgs3c2',
        },
      });
    },
    async getPublicize() {
      let res;
      let data = { paramV: 'dddd' };
      const { query } = this.$route;
      // data = JSON.stringify(data);
      try {
        res = await getPublicize({ paramV: 'fdgsdgs3c2' });
      } catch (e) {
        console.log(e);
        this.$toast({
          content: e.desc,
        });
      }
      if (res.code === 1) {
        this.linkUrl = res?.results?.linkUrl;
        this.channel = res?.results?.channel;
      }
    },
    async getUploadClickAction() {
      let res;
      const { phoneNumber } = this;
      this.visible1 = false;
      try {
        res = await getUploadClickAction({
          phone: phoneNumber,
          channel: 'fdgsdgs3c2',
        });
      } catch (e) {
        console.log(e);
      }
      this.jumpUrl();
    },
    submitAction() {
      const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
      if (!this.phoneNumber) {
        this.$toast({ content: '请填写手机号!', duration: 2000 });
      } else if (this.phoneNumber.length < 11 || !myreg.test(this.phoneNumber)) {
        this.$toast({ content: '手机号填写有误,请重新输入!', duration: 2000 });
      } else if (!this.isChecked) {
        this.$toast({ content: '请阅读并勾选用户协议', duration: 2000 });
      } else {
        this.getUploadClickAction();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pufa-page {
  max-width: 750px;
  position: relative;
  .head {
    width: 236px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -90px;
    z-index: 30;
  }
  .submit-btn {
    width: 690px;
    height: 110px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 59px;
  }
  img {
    width: 100%;
  }
  .rule-btn {
    width: 136px;
    position: absolute;
    top: 30px;
    right: 50px;
  }
  .bottom-btn {
    position: absolute;
    // padding: 0 52px;
    width: 100%;
    bottom: 50px;
    .btns {
      display: flex;
      justify-content: space-between;
      margin: 0 52px;
    }
    .btn {
      width: 306px;
    }
  }
}
.pufa-dialog {
  /deep/ .y-dialog-main {
    width: 554px;
    height: auto;
    border-radius: 12px;
    .dialog-content {
      font-size: 32px;
      font-weight: 500;
      color: #333333;
      line-height: 54px;
      margin-top: 78px;
      text-align: center;
    }
    .footer-btn {
      font-size: 32px;
      font-weight: 500;
      color: #EF5C53;
      line-height: 40px;
      padding: 30px 0;
      text-align: center;
      margin-top: 64px;
      border-top: 1PX solid #EAE7E7;
    }
  }
}
.apply-content {
  padding: 165px 49px 0 49px;
  .input {
    position: relative;
    width: 100%;
    height: 60px;
    // border-bottom: 2px solid #E5E4E4;
    input {
      border-bottom: 2px solid #E5E4E4;
    }
  }
  input {
    width: 100%;
    height: 55px;
    border: none;
    font-size: 28px;
    &::-webkit-input-placeholder {
      font-size: 28px;
      color: #CDCDCD;
    }
  }
}
.apply-btn {
  width: 538px;
  height: 79px;
  border: 2px solid #FFFFFF;
  border-radius: 40px;
  line-height: 79px;
  text-align: center;
  font-size: 47px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-style: italic;
  color: #FFFFFF;
  text-shadow: 0px 4px 5px rgba(13, 127, 134, 0.56);
  margin: 45px auto 0;
}
.agreement-content {
  // width: 576px;
  height: 204px;
  background: #F9F9F9;
  border-radius: 8px;
  overflow-y: auto;
  margin: 40px 25px;
  padding: 20px;
}
.check-module {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  align-items: center;
  > .image {
    width: 24px;
    margin-right: 10px;
    flex: 0 0 auto;
    position: relative;
    top: 3px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  span {
    font-size: 24px;
    color: #505050;
  }
}
/deep/ .y-dialog-main {
  height: auto;
}
</style>
